import axios from 'axios';

const STATUS_OK = 200;
const STATUS_CREATED = 201;
const STATUS_ERROR = 400;
const STATUS_ERROR_LOGIN = 401;
const STATUS_ERROR_VALIDATION = 422;

class HttpService {

    static get(url, params) {
        /* let config = {
             headers: {
                 'x-api-key': '20255f35a8eefe23f2a08252267f89f0e47fb3cd',
             }
         }*/

        if (!params) {
            return axios.get(url);
        }
        return axios.get(url, params);
    }

    static post(url, params) {
        /*let config = {
            headers: {
                'x-api-key': '20255f35a8eefe23f2a08252267f89f0e47fb3cd',
            }
        }*/

        return axios.post(url, params);
    }

    //todo change url in production mode
    // static apiurl() {
    //     //lordofhanfupdate.devv
    //     return 'http://lordofhanf.devv/api/v1/';
    // }

    // static apiurlV2() {
    //     //lordofhanfupdate.devv
    //     return 'http://lordofhanf.devv/api/v2/';
    // }

    // static addressImage() {
    //     //lordofhanfupdate.devv
    //     return 'http://lordofhanf.devv/';
    // }

    // static websiteUrl() {
    //     //lordofhanfupdate.devv
    //     return 'http://localhost:8080/';
    // }

    // ************************************** Production ***************************************

    static apiurl() {
        //lordofhanfupdate.devv
        return 'https://lof-laravel-production.up.railway.app/api/v1/';
    }

    static apiurlV2() {
        //lordofhanfupdate.devv
        return 'https://lof-laravel-production.up.railway.app/api/v2/';
    }

    static addressImage() {
        //lordofhanfupdate.devv
        return 'https://lof-laravel-production.up.railway.app/';
    }

    static websiteUrl() {
        //lordofhanfupdate.devv
        return 'https://lof-laravel-production.up.railway.app/';
    }

    //*************************************************

    static ok() {
        return STATUS_OK;
    }

    static created() {
        return STATUS_CREATED;
    }

    static error() {
        return STATUS_ERROR;
    }

    static errorLogin() {
        return STATUS_ERROR_LOGIN;
    }

    static errorValidation() {
        return STATUS_ERROR_VALIDATION;
    }
}

export default HttpService;